import { BOATS, NAUTICAL, OTHERS, PARTS, SERVICES, machinaryTypes } from ".";

const SALT = "mjcoders.com(motor)";
const crypt = (text) => {
    const salt = SALT;
    const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
    const byteHex = (n) => ("0" + Number(n).toString(16)).substr(-2);
    const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);
    return text
        .split("")
        .map(textToChars)
        .map(applySaltToChar)
        .map(byteHex)
        .join("");
};
const decrypt = (encoded) => {
    const salt = SALT;
    const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
    const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded
        .match(/.{1,2}/g)
        .map((hex) => parseInt(hex, 16))
        .map(applySaltToChar)
        .map((charCode) => String.fromCharCode(charCode))
        .join("");
};
export function convertToBase64(str) {
    try {
        let encode = window.btoa(unescape(encodeURIComponent(crypt(str))));
        return encode;
    } catch (e) {
        console.log(e);
        return null;
    }
}
export function convertFromBase64(str) {
    try {
        let decode = decrypt(decodeURIComponent(escape(window.atob((str)))));
        return decode;
    } catch (e) {
        return null;
    }
}
export function setLoadingState(mdata, state, res = null) {
    mdata.isLoading = state;
    if (res != null) {
        mdata.data = res;
    }
    return mdata;
}
// CHECK IF PRODUCT IS BOAD OR other or nautical or parts
export function chkBOPN(id) {
    if (id == BOATS || id == OTHERS || id == NAUTICAL || id == PARTS || id == SERVICES) {
        return true;
    } else {
        return false;
    }
}
// CHECK IF PRODUCT IS other or nautical or parts
export function chkOPN(id) {
    if (id == OTHERS || id == NAUTICAL || id == PARTS || id == SERVICES) {
        return true;
    } else {
        return false;
    }
}

export function sortingUserId(loginUserId, itemAddedUserId) {
    if (loginUserId.localeCompare(itemAddedUserId) === 1) {
        return `${itemAddedUserId}_${loginUserId}`;
    } else if (loginUserId.localeCompare(itemAddedUserId) == -1) {
        return `${loginUserId}_${itemAddedUserId}`;
    } else {
        return `${loginUserId}_${itemAddedUserId}`;
    }
}
export function currencyFormat(val){
    try{
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
            maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
        });
        let amount = Number(val);
        return formatter.format(amount).toString().replace('$', '');
    }catch(e){
        return 0;
    }  
}
export const convertNumber = (string) => {
    try{
        const number = parseInt(string);
        return number ? number : 0;
    }catch(e){
        console.log(e);
        return 0;
    }
}
export const convertDouble = (string) =>{
    try{
        const number = parseFloat(string);
        return number ? number : 0;
    }catch(e){
        console.log(e);
        return 0;
    }
}
export const createItemUrl = (val) => {
    let title = '';
    let sprationChar = '-';
    if (val.manufacturer.name || val.manufacturer_id == -1) {
        let menuTitle = val.manufacturer_id == -1 ? val.manufacturer_name : val.manufacturer.name;
        if (menuTitle) { title += menuTitle; title += sprationChar; }
    }
    if (val.model.name || val.model_id == -1) {
        let _model = val.model_id == -1 ? val.model_name : val.model.name;
        if (_model) { title += _model; title += sprationChar; };
    }
    if (hasYear(val.year)) title += val.year;
    if(val.title) title+= sprationChar+val.title;
    title = title.replaceAll(' ','_');
    if(title.length > 0) return "/"+title;
    return title;
    
}

// The API stores a missing optional text field (email, WhatsApp, "Outros"
// brand/model name) as "0"; treat that as empty everywhere it's shown or edited.
export const cleanOptional = (val) => {
    if (val === null || val === undefined) return '';
    return String(val).trim() === '0' ? '' : val;
}

// year / numeric fields come back as "0" when never filled in: not shown on the site
export const hasYear = (year) => convertNumber(year) > 0;

// rent cars: stored "Yes" / "No", shown as Sim / Não ("" when never chosen)
export const driverLabel = (val) => val === 'Yes' ? 'Sim' : (val === 'No' ? 'Não' : '');

// machinery: the stored type ("Agriculture", "Construção"...) as the site words it ("Agricultura"...)
export const machineTypeLabel = (val) => {
    const t = String(cleanOptional(val)).trim();
    const found = machinaryTypes.find((m) => m.key === t);
    return found ? found.value : t;
}

// trimmed text of an optional field ("" when missing or stored as "0")
export const optText = (val) => String(cleanOptional(val)).trim();

export const isValidEmail =(val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(cleanOptional(val)).trim());

// price 0 / empty = "no price": the price is simply not shown on the site
export const hasPrice = (price) => Number(String(price === null || price === undefined ? '' : price).replace(/,/g, '')) > 0;

// WhatsApp links need the country code: Angolan mobiles are saved as 9 digits
// starting with 9 (e.g. 923000000), so prefix 244 for those.
export const whatsappNumber = (val) => {
    const digits = String(cleanOptional(val)).replace(/\D/g, '');
    return (digits.length === 9 && digits.charAt(0) === '9') ? '244' + digits : digits;
}

// How to reach the seller when there's no price to show:
// phone first, then a real email, then WhatsApp. null when none is set.
export const getContactAction = (item) => {
    if (!item) return null;
    const phone = String(cleanOptional(item.phone_number)).trim();
    if (phone.replace(/\D/g, '').length >= 6) {
        return { type: 'phone', href: 'tel:' + phone.replace(/[^\d+]/g, ''), title: 'Ligar ' + phone };
    }
    if (isValidEmail(item.email)) {
        const email = String(item.email).trim();
        return { type: 'email', href: 'mailto:' + email, title: 'Enviar email para ' + email };
    }
    const wa = whatsappNumber(item.second_phone_number);
    if (wa.length >= 6) {
        return { type: 'whatsapp', href: 'https://wa.me/' + wa, title: 'Contactar por WhatsApp' };
    }
    return null;
}
